import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Multimedia() {

   const url_list1 = Config.api_domain + "/multimedia1/active/";
  const [list1, setList1] = useState([]);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const res = await fetch(url_list1, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList1(data.data || []);
      } catch (error) {
        console.error("Fetch error multimedia1:", error.message);
      }
    };
    fetchData1();
  }, [url_list1]);
  // State untuk bagian Events
  const url_list = Config.api_domain + "/multimedia/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

function getRows1() {
    if (list1 && list1.length > 0) {
      return list1.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={
                  Config.api_domain +
                  "/multimedia1/download/" +
                  row.public_id
                }
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data-1">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/multimedia/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Paket Pengadaan PC, Laptop, dan Peralatan Multimedia Pusat Pengembangan Kompetensi</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
Badan Informasi Geospasial (BIG) merupakan koordinator utama penyelenggaraan 
informasi geospasial di Indonesia. BIG tidak hanya bertanggung jawab untuk 
memastikan ketersediaan data geospasial yang akurat dan dapat diakses, tetapi juga 
membangun kapasitas SDM yang mampu memanfaatkan data tersebut secara efektif. Untuk memenuhi kebutuhan ini, Pusat Pengembangan Kompetensi Informasi 
Geospasial (PPKIG) Badan Informasi Geospasial dituntut untuk meningkatkan 
kapasitasnya dalam melaksanakan pengembangan kompetensi SDM. PPKIG 
merupakan unit pelaksana yang menyediakan program pengembangan kompetensi, 
salah satunya adalah pelatihan dan pendidikan, yang bertujuan untuk meningkatkan 
keahlian dan pengetahuan SDM di bidang geospasial. <br></br><br></br>Untuk menjamin suatu program pelatihan mudah dipahami dan menciptakan 
pengalaman belajar yang lebih efektif dan menarik serta mendorong tercapainya tujuan 
pelatihan atau pembelajaran, maka sangat penting untuk melengkapi suatu program 
pelatihan dengan peralatan PC, laptop dan multimedia. 
Multimedia –yang mencakup elemen visual, audio, video, animasi, dan simulasi 
interaktif– berperan penting dalam menjembatani pemahaman peserta terhadap materi 
yang kompleks atau bersifat teknis. Penyampaian melalui multimedia membantu 
memperjelas konsep, meningkatkan keterlibatan peserta, serta memperkuat daya serap 
dan retensi informasi. Hal ini sangat krusial dalam pelatihan yang membutuhkan 
visualisasi proses, penggunaan perangkat lunak, atau pemahaman data geospasial. 
Sementara itu, peralatan komputer (baik PC maupun laptop) berfungsi sebagai sarana 
utama bagi peserta dan pengajar untuk mengakses, mengolah, dan mempraktikkan 
materi pelatihan. Dalam pelatihan berbasis digital, seperti Sistem Informasi Geografis 
(SIG), Penginderaan Jauh, pengelolaan data geospasial lainnya, dan aplikasi perangkat 
lunak, ketersediaan PC maupun laptop dengan spesifikasi yang memadai menjadi 
syarat mutlak agar pelatihan berjalan optimal. 
Urgensi ini semakin meningkat dalam konteks pelatihan daring atau blended learning, di 
mana penggunaan platform pembelajaran, materi berbasis video, serta tugas interaktif 
menjadi bagian dari metode pembelajaran yang efektif.
        </p>

 <h3>Announcement (ULANG)</h3>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="announcement1">
          <TableHead>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell>Announcement</StyledTableCell>
              <StyledTableCell>Publication Date</StyledTableCell>
              <StyledTableCell>Download</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{getRows1()}</TableBody>
        </Table>
      </TableContainer>

<h3>Procurement Timeline (ULANG)</h3>
      <TableContainer component={Paper} sx={{ mb: 6 }}>
        <Table sx={{ minWidth: 500 }} aria-label="timeline1">
          <TableHead>
            <TableRow>
              <StyledTableCell>No.</StyledTableCell>
              <StyledTableCell>Activity</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <StyledTableCell>1</StyledTableCell>
              <StyledTableCell>
                Pengumuman RFQ pada website ILASP
              </StyledTableCell>
              <StyledTableCell>22 Sep 25</StyledTableCell>
              <StyledTableCell>06 Oct 25</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>2</StyledTableCell>
              <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
              <StyledTableCell>24 Sep 25 09.00 WIB (GMT+7)</StyledTableCell>
              <StyledTableCell>25 Sep 25 12.00 WIB (GMT+7)</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>3</StyledTableCell>
              <StyledTableCell>
                Pemasukan Dokumen Penawaran
              </StyledTableCell>
              <StyledTableCell>22 Sep 25</StyledTableCell>
              <StyledTableCell>06 Oct 25 12.00 WIB (GMT+7)</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>4</StyledTableCell>
              <StyledTableCell>
                Evaluasi Dokumen Penawaran
              </StyledTableCell>
              <StyledTableCell>06 Oct 25</StyledTableCell>
              <StyledTableCell>09 Oct 25</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>5</StyledTableCell>
              <StyledTableCell>
                Notification of Intention to Award
              </StyledTableCell>
              <StyledTableCell>10 Oct 25</StyledTableCell>
              <StyledTableCell>10 Oct 25</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>6</StyledTableCell>
              <StyledTableCell>
                Award of Contract and Publication of Contract Award
              </StyledTableCell>
              <StyledTableCell>11 Oct 25</StyledTableCell>
              <StyledTableCell>20 Oct 25</StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

<h3>Procurement Timeline</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}> 
  <Table sx={{ minWidth: 500 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
        <StyledTableCell>25 Aug 2025</StyledTableCell>
        <StyledTableCell>08 Sep 2025</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
        <StyledTableCell>27 Aug 2025</StyledTableCell>
        <StyledTableCell>28 Aug 2025</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Pemasukan Dokumen Penawaran (UPDATED)</StyledTableCell>
        <StyledTableCell>25 Aug 2025</StyledTableCell>
        <StyledTableCell>15 Sep 2025 12:00 WIB (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Evaluasi Dokumen Penawaran (UPDATED)</StyledTableCell>
        <StyledTableCell>15 Sep 2025</StyledTableCell>
        <StyledTableCell>18 Sep 2025</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Notification of Intention to Award (UPDATED)</StyledTableCell>
        <StyledTableCell>19 Sep 2025</StyledTableCell>
        <StyledTableCell>19 Sep 2025</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Award of Contract and Publication of Contract Award (UPDATED)</StyledTableCell>
        <StyledTableCell>20 Sep 2025</StyledTableCell>
        <StyledTableCell>29 Sep 2025</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>


<p style={{ textAlign: "justify" }}>
  Klarifikasi dan pertanyaan disampaikan melalui email{" "}
  <a
    href="mailto:pokja.ppkig@big.go.id"
    style={{ color: "#1976d2", textDecoration: "underline" }}
  >
    pokja.ppkig@big.go.id
  </a> pada
Pelaksanaan Penjelasan (Aanwijzing) pengadaan barang ini pada hari Rabu, 24
September 2025 pukul 09.00 WIB sampai dengan Kamis, 25 September 2025 pukul
12.00 WIB.
</p>




      </Container>
    </div>
  );
}

export default Multimedia;
